import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "./pages/LandingPage";
import ScannerPage from "./pages/ScannerPage";
import ResultsPage from "./pages/ResultsPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import BlogIndexPage from "./pages/BlogIndexPage";
import Blog1 from "./pages/Blog1";
import Blog2 from "./pages/Blog2";
import Blog3 from "./pages/Blog3";
import Blog4 from "./pages/Blog4";
import CookieConsent from "./components/CookieConsent";

import "./App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" />
        <CookieConsent />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/scanner" element={<ScannerPage />} />
          <Route path="/results/:scanId" element={<ResultsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/blog" element={<BlogIndexPage />} />
          <Route
            path="/blog/how-to-check-website-security"
            element={<Blog1 />}
          />
          <Route
            path="/blog/http-security-headers-explained"
            element={<Blog2 />}
          />
          <Route
            path="/blog/ssl-certificate-explained-india"
            element={<Blog3 />}
          />
          <Route
            path="/blog/website-security-checklist-small-business-india"
            element={<Blog4 />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
